var _dec, _class;
import { mixins, Options } from 'vue-class-component';
import WebMenu from '../web-menu/WebMenu.vue';
import Login from '../login/Login.vue';
import { HomeViewModel } from './HomeViewModel';
let Doc = (_dec = Options({
  components: {
    WebMenu,
    Login
  }
}), _dec(_class = class Doc extends mixins(HomeViewModel) {}) || _class);
export { Doc as default };